<template>
  <div class="step">
    <template v-for="(stepItem, index) in stepArr">
      <!-- 默认样式 -->
      <template v-if="type === 'step'">
        <div
          :class="['step-wrap', {'step-default': type === 'step'}]"
          :key="index"
          :style="{width: stepWdith}"
        >
          <div :class="['step-head', setStepHeadActiveClass(index)]">
            <div 
              v-if="stepItem.itemType === 'icon'"
              class="step-icon icon"
            >
              <i class="iconfont" v-html="stepItem.icon"></i>
            </div>
            <div
              v-else
              :class="['step-icon default', 'icon'+(index+1)]"
            >
              <p v-html="setpHeadText(stepItem, index)"></p>
            </div>
            <template v-if="index < stepArr.length - 1">
              <div class="step-line"></div>
              <div class="step-arrow"></div>
            </template>
          </div>
          <div :class="['step-main', setStepMainActiveClass(index)]">
            <div class="step-title" >
              <slot name="title">{{ stepItem.title ? stepItem.title : stepItem }}</slot>
            </div>
          </div>
        </div>
      </template>
      <!-- 圆点型 -->
      <template v-if="type === 'dot'">
        <div
          :class="['step-wrap', activeColorCls, {active: active >= index+1}, {'step-dot': type === 'dot'}]"
          :key="index"
          :style="{width: stepWdith}">
          <div class="step-head">
            <span class="line" v-show="index > 0"></span>
            <span 
              :class="['dot', {small: active !== index + 1}]"
              :style="{borderColor: dotBordorColor}"
            ></span>
          </div>
          <div class="step-main">
            <p class="step-main__title">{{stepItem.title ? stepItem.title : stepItem}}</p>
            <p class="step-main__decs" v-if="stepItem.desc">{{stepItem.desc}}</p>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      // 步骤条描述
      stepArr: Array,
      // 当前激活步骤
      active: Number,
      // 类型  step or dot
      type: {
        type: String,
        default: 'step'
      },
      // dot模式，圆点边框色，防止步骤条底部有背景色导致视觉问题
      dotBordorColor: {
        type: String,
        default: '#fff'
      },
      // 步骤条激活颜色class
      activeColorCls: {
        type: String,
        default: 'font-color-guide'
      }
    },
    computed: {
      // 步骤条总数
      stepCount () {
        return this.stepArr.length
      },
      // 步骤条宽度
      stepWdith () {
        return 100 / this.stepCount + '%'
      }
    },
    methods: {
      // step头部显示icon或序号
      setpHeadText (item, index) {
        return item.icon ? item.icon : index + 1
      },
      setStepHeadActiveClass (index) {
        return this.active >= index + 1 ? this.activeColorCls : 'font-color-theme-fading-2'
      },
      setStepMainActiveClass (index) {
        return this.active >= index + 1 ? 'font-color-primary' : 'font-color-primary-light-3'
      }
    },
    watch: {
      active (newVal, oldVal) {
        this.setStepHeadActiveClass(newVal - 1)
        this.setStepMainActiveClass(newVal - 1)
        this.$emit('change', newVal, oldVal)
      }
    }
  }
</script>

<style lang="scss" scoped>
  
  .step {
    white-space: nowrap;
    width: 100%;
    font-size: 0;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    .step-default.step-wrap {
      display: inline-block;
      text-align: center;
      vertical-align: top;
      .step-head {
        position: relative;
        width: 100%;
        .step-line {
          height: 2px;
          background: url($img-url+'1544680151518border.png') repeat-x;
          position: absolute;
          top: 16px;
          left: 62%;
          right: -30%;
        }
        .step-arrow {
          width: 5px;
          height: 9px;
          background: url($img-url+'1544681395910arrows.png') no-repeat;
          position: absolute;
          right: -35%;
          top: 13px;
        }
        .step-icon {
          text-align: center;
          font-size: 16px;
          display: inline-block;
          background-size: 100%;
          background-repeat: no-repeat;
          &.default {
            background-color: currentColor;
            width: 34px;
            height: 34px;
            border-radius: 50%;
            line-height: 34px;
          }
          &.icon {
            color: currentColor;
            line-height: 1;
            i {
              font-size: 30px;
            }
          }
          p {
            color: #fff;
          }
          &.icon1 {
            background-image: url($img-url+'1545050341487step1.png');
          }
          &.icon2 {
            background-image: url($img-url+'1545050320070step2.png');
          }
          &.icon3 {
            background-image: url($img-url+'1545050272098step3.png');
          }
          &.icon4 {
            background-image: url($img-url+'1545050295085step4.png');
          }
          &.step-active {
            background-color: currentColor;
          }
        }
      }
      .step-title {
        color: currentColor;
        line-height: 1.5;
        margin-top: 8px;
        font-size: 12px;
        white-space: normal;
        word-break: break-all;
        &.step-active {
          color: currentColor;
        }
      }
    }
  }
  // 圆点步骤
  .step-dot.step-wrap {
    display: inline-block;
    text-align: center;
    vertical-align: top;
    .step-head {
      height: 20px;
      position: relative;
      padding: 13px 0;
      margin: 0 auto;
      width: 100%;
      .dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        display: block;
        border: 4px solid #fff;
        position: absolute;
        top: 13px;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 2;
        &.small {
          width: 8px;
          height: 8px;
          margin-top: 2px;
        }
      }
      .line {
        height: 2px;
        display: block;
        position: absolute;
        top: 22px;
        left: -50%;
        right: 50%;
        z-index: 1;
      }
      .line,
      .dot {
        background-color: #c5c5c5;
      }
    }
    .step-main {
      line-height: 1;
      color: $minor-color;
      .step-main__title {
        font-size: 14px;
        font-weight: 500;
      }
      .step-main__decs {
        margin: 0 30px;
        line-height: 1.4;
        white-space: normal;
        margin-top: 5px;
      }
    }
    &.active {
      .step-head {
        .dot,
        .line {
          background-color: currentColor;
        }
      }
      .step-main__title {
        color: $font-color;
      }
    }
  }
</style>
